import { Box, Stack, Typography } from "@mui/material";
import { primary, themeColors } from "../utils/MUIStylePresets";

export default function Footer() {
  return (
    <Box mb={10} ml={4}>
      <Stack>
        <Typography
          variant={"smallbook"}
          sx={{ color: themeColors("text"), textTransform: "uppercase" }}
        >
          © {new Date().getFullYear()} NextUp Solutions
        </Typography>
        <Typography
          variant={"smallbook"}
          mt={0.5}
          sx={{ color: primary, textTransform: "uppercase" }}
        >
          Côte-à-Deux-Sous 6
        </Typography>
        <Typography
          variant={"smallbook"}
          sx={{ color: primary, textTransform: "uppercase" }}
        >
          1052 Le Mont-sur-Lausanne
        </Typography>
      </Stack>
    </Box>
  );
}
